import PromotionView from "./PromotionView";

export default PromotionView;
